import { render, staticRenderFns } from "./MaterialCodeModal3.vue?vue&type=template&id=f4fac0f2&"
import script from "./MaterialCodeModal3.vue?vue&type=script&lang=js&"
export * from "./MaterialCodeModal3.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCodeModal3.vue?vue&type=style&index=0&id=f4fac0f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports